import { createSlice } from "@reduxjs/toolkit";

const superAdminData = JSON.parse(localStorage.getItem("superAdmin"));

export const userSlice = createSlice({
    name: 'username',
    initialState: {
        user: null,
        roleId: superAdminData?.roleId || null, 
    },
    reducers: {
        login: (state, action) => {
            state.user = action.payload
        },
        logout: (state) => {
            state.user = null;
        },
         setRoleId: (state, action) => {   
            state.roleId = action.payload;
        }
    }
})

export const { login, logout,setRoleId  } = userSlice.actions

export const selectUser=(state)=>state.user.user
export const selectRoleId = (state) => state.user.roleId; 

export default userSlice.reducer;